import React from 'react'
import { Link } from 'react-router'
import style from '../style.module.less'

export default ({ icon, link, href, title, onClick }) => {
  return (
    <>
      {href ? (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={style.link}
          onClick={onClick}
        >
          {icon && <i className={`iconfont ${icon}`} />}
          {title}
        </a>
      ) : (
        <Link to={link} className={style.link} onClick={onClick}>
          {icon && <i className={`iconfont ${icon}`} />}
          {title}
        </Link>
      )}
    </>
  )
}
